/**
 * Configurazione centralizzata dell'applicazione.
 * Tenere qui le costanti evita "magic number" sparsi nel codice e rende
 * banale cambiare endpoint o dimensione di pagina in un punto solo.
 */
export const CONFIG = Object.freeze({
  /** Base URL delle API pubbliche di Hacker News (v0). */
  API_BASE_URL: 'https://hacker-news.firebaseio.com/v0',

  /** Endpoint che restituisce l'elenco (~500) degli ID delle ultime storie. */
  NEW_STORIES_PATH: '/newstories.json',

  /** Numero di news mostrate al primo caricamento e a ogni "Load more". */
  PAGE_SIZE: 10,

  /** Timeout delle richieste HTTP in millisecondi. */
  REQUEST_TIMEOUT: 10_000,

  /** Numero di tentativi extra in caso di errore di rete. */
  MAX_RETRIES: 2,

  /** Ritardo base (ms) del backoff esponenziale tra due tentativi. */
  RETRY_DELAY: 400,

  /** URL di una discussione su Hacker News (fallback quando la news non ha `url`). */
  HN_ITEM_URL: 'https://news.ycombinator.com/item?id=',

  /** Chiavi usate in localStorage. */
  STORAGE_KEYS: Object.freeze({
    FAVORITES: 'tongue:favorites',
    THEME: 'tongue:theme',
  }),
});
